<sbnb-signup-user-header></sbnb-signup-user-header>
<p>We can see that you're working with someone who is already using Hospitable.</p>
<p>Please reach out to the account holder if you'd like an invitation to access their Hospitable account.</p>
